import React, { useState, useEffect, useRef } from "react";

import { useHistory, useLocation } from 'react-router-dom';

import axios from 'axios';
import { HasAnyAuthToken } from '../../Utils/AuthToken';
import { AddSession, ExtractSession } from "../../useAuth/SessionExtract";
import { decrypt } from "../../Utils/cryptoStorage";

const UrlCheck = () => {

    const history = useHistory();
    const location = useLocation();
    const tokenSetRef = useRef(false);
    // const tokenRef = useRef(false);
    // const [isAuth, setIsAuth] = useState();
    const [authData, setAuthData] = useState();
    console.log('check');

    const tokenTypes = ['truck_email_approval_token', 'email_approval_token', 'no_token'];

    const tokenMap = {
        // service_recovery_token: "ASR",
        // ServerIWI: "ServerIWI",
        no_token: "NO_TOKEN",
        trucking_token: "Trucking",
        email_approval_token: "EMAIL",
        truck_email_approval_token: "TEMAIL",
        time_tracker: "TTRACKER",
        // ULD_token: "ULD",
        // RFS_token: "RFS",
        // ASR_token: "ASR",
    };

    useEffect(() => {
        const loadData = async () => {
            const queryParameters = new URLSearchParams(window.location.search);
            const hasToken = tokenTypes.some(token => queryParameters.has(token));
            const findName = tokenTypes.find(token => queryParameters.has(token));
            
            if (hasToken) {
                const objData = {
                    [tokenMap[findName]]: queryParameters.get(findName),
                    // UserID: userId,
                    // UserType: userType,
                    // LoginUser: loginUserType,
                    // OrgType: orgType,
                    orgName: queryParameters.get("org_name"),
                    // Email: userEmail,
                    // GoBack: backUrl,
                    // LogOut: logOutPath,
                    // login_from: loginFrom,
                    truck_id: queryParameters.get("truck_request_id"),
                    CEmail: queryParameters.get('email'),
                    person: queryParameters.get('person'),
                    key: queryParameters.get('key'),
                    orgLogo: queryParameters.get('org_logo'),
                }
                console.log('objData', objData);
                AddSession('__A-', objData)
                if (objData.TEMAIL) {
                    window.location.replace('/Truck-Confirmation-form')
                } else if (objData.NO_TOKEN) {
                    window.location.replace('/Driver-Visitor-Registration')
                }
                
            }
            const encryptedData = sessionStorage.getItem('__A-');

            if (encryptedData) {
                const data = await decrypt(encryptedData);

                setAuthData(data);

                if (!data?.token) {
                    // if (!tokenRef.current) {
                    history.replace("/Login");
                    return;
                } else {
                    const lastPath = sessionStorage.getItem('loc');
                    if (lastPath) {
                        history.replace(lastPath);
                    }
                }



                if (localStorage.getItem('Trucking')) {
                    history.replace('/TruckMonitor')
                    // } else if (localStorage.getItem('SAToken')) {
                } else if (data?.login_user_type === 'SA' && data?.org_type === 'SA') {
                    history.replace('/SuperAdmin')
                } else if (localStorage.getItem('EMAIL')) {
                    history.replace('/Confirmation-form')
                } else if (localStorage.getItem('TEMAIL')) {
                    history.replace('/Truck-Confirmation-form')
                } else if (localStorage.getItem('TTRACKER')) {
                    history.replace('/RFS-Time-Tracker')
                } else if (localStorage.getItem('NO_TOKEN')) {
                    history.replace('/Driver-Visitor-Registration')
                    // } else if (localStorage.getItem('ULD') && localStorage.getItem('OrgType') == 'A') {
                } else if (data?.org_type === 'A') {
                    history.replace('/ULDControl')
                } else if (localStorage.getItem('RFS') && localStorage.getItem('OrgType') == 'A') {
                    history.replace('/BookingtruckSchedule')
                } else if (localStorage.getItem('RFS') && localStorage.getItem('OrgType') == 'H') {
                    history.replace('/HandlerTruckMonitor')
                }
                else if (localStorage.getItem('ULD') && localStorage.getItem('OrgType') == 'E') { // not live
                    history.replace('/ULDForwarder/ActiveTrips')
                    forwarderRedirect('ULD')
                }
                else if (localStorage.getItem('RFS') && localStorage.getItem('OrgType') == 'E') {
                    history.replace('/ForwarderShipments/Export')
                    forwarderRedirect('RFS')
                } else if (localStorage.getItem('ASR')) {
                    history.replace('/ServiceRecovery')
                } else if (localStorage.getItem('OrgType') == 'B') {
                    history.replace('/QuoteRequest')
                } else {
                    if (localStorage.getItem('OrgType') == 'H') {
                        history.replace('/HandlerAdmin')
                    } else {
                        if (localStorage.getItem('OrgType') == 'E') {
                            forwarderRedirect('', 'D')
                        } else {
                            history.replace('/Dashboard')
                        }
                    }
                }
            } else {
                history.replace("/Login");
            }
        };
        loadData();
    }, []); // location.pathname, history, location.search

    // useEffect(() => {
    //     console.log("Decrypted data:", authData);

    //     if (authData) {
    //         // Do your checking here
    //     }
    // }, [authData]);

    let tokenSet = false;

    // useEffect(() => {
    //     const encryptedData = localStorage.getItem('auths');

    //     const data = decrypt(encryptedData);
    //     console.log("Decrypted data:++++", data);
    //     const queryParameters = new URLSearchParams(window.location.search);
    //     const tokenTypes = [
    //         // 'airlinetoken',
    //         'forwardertoken',
    //         'service_recovery_token', 'handler_recovery_token', 'email_approval_token', 'trucking_token', 'truck_email_approval_token',
    //         'ULD_token', 'RFS_token', 'ASR_token', 'time_tracker', 'ServerIWI', 'no_token'
    //     ];

    //     const removeOtherTokens = (keepKey) => {
    //         const allTokens = [
    //             'RFS', 'ULD', 'ASR', 'EMAIL', 'TEMAIL', 'Trucking', 'TTRACKER', 'ServerIWI', 'airlinetoken', 'forwardertoken', 'DVR', 'NO_TOKEN', 'SPL', 'SuperAdminToken'
    //         ];
    //         allTokens.forEach((key) => {
    //             if (key !== keepKey) localStorage.removeItem(key);
    //         });
    //     };
    //     const tokenMap = {
    //         service_recovery_token: "ASR",
    //         ServerIWI: "ServerIWI",
    //         no_token: "NO_TOKEN",
    //         trucking_token: "Trucking",
    //         email_approval_token: "EMAIL",
    //         truck_email_approval_token: "TEMAIL",
    //         time_tracker: "TTRACKER",
    //         ULD_token: "ULD",
    //         RFS_token: "RFS",
    //         ASR_token: "ASR",
    //     };

    //     let foundToken = false;
    //     for (let type of tokenTypes) {
    //         // if (!type) { window.location.replace('/Login'); return; }
    //         const tokenValue = queryParameters.get(type);
    //         if (!tokenValue) continue;
    //         foundToken = true;
    //         tokenSetRef.current = true;

    //         const userName = queryParameters.get("user_name");
    //         const userId = queryParameters.get("user_id");
    //         const userType = queryParameters.get("user_type");
    //         const loginUserType = queryParameters.get("login_user_type");
    //         const orgType = queryParameters.get("org_type");
    //         const orgName = queryParameters.get("org_name");
    //         // console.log("🚀 ~ useEffect ~ orgType:", orgType)
    //         const userEmail = queryParameters.get("email_id");
    //         const backUrl = queryParameters.get("back_url");
    //         const logOutPath = queryParameters.get("logout_path");
    //         const portal = queryParameters.get("portal");
    //         const loginFrom = queryParameters.get("login_from");
    //         const truckId = queryParameters.get("truck_request_id");

    //         const tokenEmail = queryParameters.get('email_approval_token');
    //         const recEmail = queryParameters.get('email');
    //         const emailData = queryParameters.get('data');
    //         const localStorageDataEmail = localStorage.getItem('EMAIL');
    //         const person = queryParameters.get('person');
    //         const key = queryParameters.get('key');
    //         const orgLogo = queryParameters.get('org_logo');
    //         // localStorage.clear();

    //         const setIfHasValue = (key, value) => {
    //             if (value !== null && value !== undefined && value !== "") {
    //                 // localStorage.setItem(key, value);
    //             }
    //         };
    //         // console.log('URL CHECK');


    //         if (tokenValue) {
    //             setIfHasValue('User', userName);
    //             setIfHasValue('UserID', userId);
    //             setIfHasValue('UserType', userType);
    //             setIfHasValue('LoginUser', loginUserType);
    //             setIfHasValue('OrgType', orgType);
    //             setIfHasValue('OrgName', orgName);
    //             setIfHasValue('Email', userEmail);
    //             setIfHasValue('GoBack', backUrl);
    //             setIfHasValue('LogOut', logOutPath);
    //             setIfHasValue('login_from', loginFrom);
    //             setIfHasValue('truck_id', truckId);
    //             setIfHasValue('CEmail', recEmail);
    //             setIfHasValue('person', person);
    //             setIfHasValue('key', key);
    //             setIfHasValue('orgLogo', orgLogo);
    //             if (portal) {
    //                 localStorage.setItem('portal', portal); // cclp_env
    //             } else {
    //                 localStorage.removeItem('portal');
    //             }

    //             const storageKey = tokenMap[type] || type;
    //             localStorage.setItem(storageKey, tokenValue);
    //             tokenSet = true;
    //             if (storageKey != 'NO_TOKEN') {
    //                 removeOtherTokens(storageKey);
    //             }

    //             queryParameters.delete(type);
    //             break; // Stop after finding the first valid token
    //         }
    //     }
    //     // console.log('aaaaaaaaaaaaaaaaaaa', foundToken, HasAnyAuthToken());

    //     // if (!foundToken && !HasAnyAuthToken()) {
    //     // const user = JSON.parse(sessionStorage.getItem('auth'));
    //     // if (!user.token) {
    //     console.log('authData=url', authData);
    //     if (!data?.token) {
    //         // if (!tokenRef.current) {
    //         history.push("/Login");
    //         return;
    //     }
    //     // if (!foundToken) { window.location.replace('/Login') }
    // }, []);


    // useEffect(() => {
    //     // if (!tokenSetRef.current && !HasAnyAuthToken()) return;
    //     // if (!tokenRef.current) return;

    //     // const user = JSON.parse(sessionStorage.getItem('auth'));
    //     console.log('authData=url+2', authData);

    //     if (!authData) return;
    //     if (localStorage.getItem('Trucking')) {
    //         history.replace('/TruckMonitor')
    //         // } else if (localStorage.getItem('SAToken')) {
    //     } else if (authData?.login_user_type === 'SA') {
    //         history.replace('/SuperAdmin')
    //     } else if (localStorage.getItem('EMAIL')) {
    //         history.replace('/Confirmation-form')
    //     } else if (localStorage.getItem('TEMAIL')) {
    //         history.replace('/Truck-Confirmation-form')
    //     } else if (localStorage.getItem('TTRACKER')) {
    //         history.replace('/RFS-Time-Tracker')
    //     } else if (localStorage.getItem('NO_TOKEN')) {
    //         history.replace('/Driver-Visitor-Registration')
    //     } else if (localStorage.getItem('ULD') && localStorage.getItem('OrgType') == 'A') {
    //         history.replace('/ULDControl')
    //     } else if (localStorage.getItem('RFS') && localStorage.getItem('OrgType') == 'A') {
    //         history.replace('/BookingtruckSchedule')
    //     } else if (localStorage.getItem('RFS') && localStorage.getItem('OrgType') == 'H') {
    //         history.replace('/HandlerTruckMonitor')
    //     }
    //     else if (localStorage.getItem('ULD') && localStorage.getItem('OrgType') == 'E') { // not live
    //         history.replace('/ULDForwarder/ActiveTrips')
    //         forwarderRedirect('ULD')
    //     }
    //     else if (localStorage.getItem('RFS') && localStorage.getItem('OrgType') == 'E') {
    //         history.replace('/ForwarderShipments/Export')
    //         forwarderRedirect('RFS')
    //     } else if (localStorage.getItem('ASR')) {
    //         history.replace('/ServiceRecovery')
    //     } else if (localStorage.getItem('OrgType') == 'B') {
    //         history.replace('/QuoteRequest')
    //     } else {
    //         if (localStorage.getItem('OrgType') == 'H') {
    //             history.replace('/HandlerAdmin')
    //         } else {
    //             if (localStorage.getItem('OrgType') == 'E') {
    //                 forwarderRedirect('', 'D')
    //             } else {
    //                 history.replace('/Dashboard')
    //             }
    //         }
    //     }

    //     // }
    // }, [location.pathname, history, location.search, authData]);

    const forwarderRedirect = async (pos, sec) => {
        try {
            // const res = await withRFSToken.get('forwarder-user-setting/get-setting', {});
            const token = localStorage.getItem('airlinetoken');

            const res = await axios.get(
                `${process.env.REACT_APP_RFS_URL}forwarder-user-setting/get-setting`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );
            if (res.data.response_code === 200) {
                const innerData = res.data.response_data.settings.tab_preferences
                console.log("🚀 ~ forwarderRedirect ~ innerData:", innerData)
                if (innerData) {
                    localStorage.setItem('FSTab', innerData)
                } else {
                    localStorage.setItem('FSTab', 'ShipmentRecords')
                }
                if (sec) {
                    window.location.replace('/Dashboard')
                }
                if (pos == 'RFS') {
                    window.location.replace(`/ForwarderShipments/${innerData ? innerData : 'ShipmentRecords'}`)
                }
            } else {
                window.location.replace(`/ForwarderShipments/ShipmentRecords`)
                // toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const fetchRefresh = async () => {
        const airlineTokenValue = localStorage.getItem("airlinetoken") || localStorage.getItem("Trucking");
        if (!airlineTokenValue) return; // ✅ skip if no airline token
        try {
            const res = await axios.post(`${process.env.REACT_APP_RFS_URL}set-cookie`, {},
                {
                    headers: { 'Authorization': `Bearer ${airlineTokenValue}` },
                    withCredentials: true
                }
            );
            if (res.data.response_data) {
                sessionStorage.setItem('aaaaaa', JSON.stringify(res.data.response_data))
            }
        } catch (error) {
            console.error('Error fetching refresh:', error);
        }
    };

    // return (
    //     <div>UrlCheck</div>
    // )
}

export default UrlCheck